import SmsIntegrationPage from './SmsIntegrationPage';
export default SmsIntegrationPage;